import { render, staticRenderFns } from "./StructureCard.vue?vue&type=template&id=49495711&scoped=true&"
import script from "./StructureCard.vue?vue&type=script&lang=js&"
export * from "./StructureCard.vue?vue&type=script&lang=js&"
import style0 from "./StructureCard.vue?vue&type=style&index=0&id=49495711&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49495711",
  null
  
)

export default component.exports